import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  getCLientResume,
  getProductsDetails,
} from '../../services/ClientServices/getClientService'

export const useClientDetails = () => {
  const { id } = useParams()

  const [clientResume, setClientResume] = useState<GetProductResumeType>()
  const [productsDetails, setProductsDetails] = useState<GetDetailsType[]>([])
  const [productsLow, setProductsLow] = useState<GetDetailsType[]>([])
  const [isLoading, setIsloading] = useState(true)
  const [isProdutosEmAltaEmBaixa, setIsProdutosEmAltaEmBaixa] = useState(false)
  const [isHistoricoProdutoEsgotando, setIsHistoricoProdutoEsgotando] =
    useState(false)

  const handleGetClient = async () => {
    setIsloading(true)
    const result = await getCLientResume(id!)
    setIsloading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setClientResume(result)
    }
  }

  const handleProducts = async (
    status: Classification,
    callback: (result: GetDetailsType[]) => void
  ) => {
    setIsloading(true)
    const result = await getProductsDetails(id!, status)
    setIsloading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      callback(result)
    }
  }

  const handleProductsInHigh = (result: GetDetailsType[]) => {
    const resultMapped = result.map(product => ({
      ...product,
      percentual: String(product.percentual).replace('.', ','),
    }))
    setProductsDetails(resultMapped)
  }

  const handleProductsLow = (result: GetDetailsType[]) => {
    const resultMapped = result.map(product => ({
      ...product,
      percentual: String(product.percentual).replace('.', ','),
    }))
    setProductsLow(resultMapped)
  }

  const handleIsProdutosEmAltaEmBaixa = () => {
    setIsProdutosEmAltaEmBaixa(!isProdutosEmAltaEmBaixa)
  }

  const handleIsHistoricoProdutoEsgotando = () => {
    setIsHistoricoProdutoEsgotando(!isHistoricoProdutoEsgotando)
  }

  useEffect(() => {
    handleGetClient()
  }, [])

  useEffect(() => {
    handleProducts('EM_ALTA', handleProductsInHigh)
    handleProducts('EM_BAIXA', handleProductsLow)
  }, [])

  return {
    clientResume,
    productsDetails,
    productsLow,
    isLoading,
    isHistoricoProdutoEsgotando,
    isProdutosEmAltaEmBaixa,
    handleIsHistoricoProdutoEsgotando,
    handleIsProdutosEmAltaEmBaixa,
  }
}
